import { CheckIcon } from "@heroicons/react/solid";
import React from "react";
import classes from "./price.module.css";
import { Zoom, Bounce, Fade, Flip } from "react-reveal";

const PriceYoutube = () => {
  return (
    <div>
      <div className="max-w-[1320px] mx-auto flex  mt-10 justify-around xl:justify-evenly flex-wrap">
        <Bounce left>
          <div className={classes.youtube_scale_container}>
            <p className="bg-[#1b0c3e] -mt-[2px] border-3 border-b-[5px] border-[#1b0c3e] text-white font-semibold text-center rounded-t-md">
              Video Editing Monthly Subscription
            </p>
            <div className="py-8">
              <h1 className="text-[34px] font-bold text-center text-[#1b0c3e]">
                SCALE
              </h1>
              <p className="text-center text-lg font-semibold text-[#1b0c3e] px-[10%]">
                Get medium volume of videos done-well by our dedicated editors
                hele.
              </p>
              <div className="text-center">
                <span className={classes.glow_youtube_price}>$899</span>
                <span className="text-2xl font-semibold ">/mon</span>
              </div>
              <p className="text-center text-lg font-semibold text-[#1b0c3e] px-[10%]">
                Saved $270 when paid quarterly.
              </p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#1b0c3e] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-bold">1-2 days turnaround</p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#1b0c3e] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-semibold">
                Unlimited orders / revisions
              </p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#1b0c3e] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-semibold">
                Dedicated Video Editors
              </p>
            </div>
            <div className="flex items-center px-6 my-3">
              <p className="text-[17px] font-semibold">Possible Add one:</p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#1b0c3e] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-semibold">
                Creative director ($99)
              </p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#1b0c3e] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-semibold">
                Unique video template ($199)
              </p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#1b0c3e] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-semibold">See More Features</p>
            </div>
            <button className="w-[90.5%] mx-6 border-[3px] transition-all .3s ease-out hover:bg-white hover:text-[#1b0c3e] bg-[#1b0c3e] text-white font-bold rounded-[8px] mt-4 my-3 p-[10px] border-[#1b0c3e]">
              GET STARTED
            </button>
          </div>
        </Bounce>
        <Bounce right>
          <div className={classes.youtube_pro_container}>
            <p className="bg-[#508dff] -mt-[2px] border-3 border-b-[5px] rounded-t-md border-[#508dff] text-white font-semibold text-center">
              Video Editing Monthly Subscription
            </p>
            <div className="py-8">
              <h1 className="text-[34px] font-bold text-center text-[#508dff]">
                PRO
              </h1>
              <p className="text-center text-lg font-semibold text-[#1b0c3e] px-[10%]">
                Get hight volume of videos done-well by our dedicated editors
                hele.
              </p>
              <div className="text-center">
                <span className={classes.glow_youtube_price_pro}>$899</span>
                <span className="text-2xl font-semibold text-[#508dff] ">
                  /mon
                </span>
              </div>
              <p className="text-center text-lg font-semibold text-[#1b0c3e] px-[10%]">
                Saved $270 when paid quarterly.
              </p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#508dff] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-bold">1-2 days turnaround</p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#508dff] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-semibold">
                Unlimited orders / revisions
              </p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#508dff] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-semibold">
                Dedicated Video Editors
              </p>
            </div>
            <div className="flex items-center px-6 my-3">
              <p className="text-[17px] font-semibold">Possible Add one:</p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#508dff] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-semibold">
                Creative director ($99)
              </p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#508dff] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-semibold">
                Unique video template ($199)
              </p>
            </div>
            <div className="flex items-center px-6 mb-2">
              <div className="flex items-center p-[2px] mr-3 justify-center bg-[#508dff] rounded-full w-5 h-5 ">
                <CheckIcon className="w-5 h-5 text-white" />
              </div>
              <p className="text-[17px] font-semibold">See More Features</p>
            </div>
            <button className="w-[90.5%] transition-all .3s ease-out  mx-6 border-[3px] text-lg bg-[#508dff] hover:bg-white hover:text-[#508dff] border-[#508dff] mt-4 text-white font-bold rounded-[8px] my-3 p-[10px]">
              GET STARTED
            </button>
          </div>
        </Bounce>
      </div>
    </div>
  );
};

export default PriceYoutube;
